
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 text-center">
      <AlertTriangle className="mb-6 h-16 w-16 text-navy-700" />
      <h1 className="mb-4 text-4xl font-bold text-navy-800">404</h1>
      <p className="mb-6 text-xl text-gray-600">
        Oops! We couldn't find the page you're looking for.
      </p>
      <Link to="/">
        <Button className="bg-navy-700 hover:bg-navy-800">
          Return to Home
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
